/**
 * ScrollContainerContext - Provides the scroll container DOM element to descendants.
 *
 * AppShell provides the <main> element as the scroll container so that
 * IntersectionObserver-based hooks can use it as the observer root
 * (instead of the browser viewport, which doesn't work for elements
 * inside a scrollable container).
 */

import { createContext, useContext } from 'react'

export const ScrollContainerContext = createContext<HTMLElement | null>(null)

export function useScrollContainer(): HTMLElement | null {
  return useContext(ScrollContainerContext)
}
